import { useState } from "react";
import api from "@/lib/api";
import { MessageCircle, X, Send } from "lucide-react";
import { logger } from "@/lib/logger";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ id: "welcome", role: "assistant", content: "Hi, I'm the BOLAWPRESS concierge. How can I help with your project?" }]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [session] = useState(() => "cust-" + Math.random().toString(36).slice(2));

  const send = async () => {
    if (!input.trim() || loading) return;
    const q = input; setInput(""); setLoading(true);
    setMsgs(m => [...m, { id: `u-${Date.now()}`, role: "user", content: q }]);
    try {
      const { data } = await api.post("/ai/chat", { session_id: session, message: q, context: "customer" });
      setMsgs(m => [...m, { id: `a-${Date.now()}`, role: "assistant", content: data.reply }]);
    } catch (err) {
      logger.error("Chat failed:", err);
      setMsgs(m => [...m, { id: `err-${Date.now()}`, role: "assistant", content: "I'm briefly unavailable. Please request a custom quote and we'll respond quickly." }]);
    }
    finally { setLoading(false); }
  };

  return (
    <>
      <button onClick={() => setOpen(!open)} data-testid="chat-toggle" className="fixed bottom-6 right-6 z-40 bg-[#0a0a0a] hover:bg-[#C5A059] hover:text-[#0a0a0a] text-white p-4 shadow-lg transition-colors">
        {open ? <X size={20} /> : <MessageCircle size={20} />}
      </button>
      {open && (
        <div className="fixed bottom-24 right-6 z-40 w-[380px] max-w-[calc(100vw-3rem)] h-[520px] bg-white border border-[#E5E5E5] shadow-xl flex flex-col" data-testid="chat-window">
          <div className="p-4 border-b border-[#E5E5E5] bg-[#0a0a0a] text-white">
            <p className="text-[10px] font-mono tracking-[0.3em] uppercase text-[#C5A059]">Concierge</p>
            <p className="font-serif text-xl">Ask BOLAWPRESS</p>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            {msgs.map((m) => (
              <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[85%] px-3 py-2 text-sm ${m.role === "user" ? "bg-[#0a0a0a] text-white" : "bg-[#FAFAFA] border border-[#E5E5E5]"}`}>{m.content}</div>
              </div>
            ))}
            {loading && <p className="text-xs font-mono text-[#888]">thinking…</p>}
          </div>
          <div className="border-t border-[#E5E5E5] p-3 flex gap-2">
            <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Type a message…" className="flex-1 border border-[#E5E5E5] bg-[#FAFAFA] px-3 py-2 text-sm focus:outline-none focus:border-[#C5A059]" data-testid="chat-input" />
            <button onClick={send} disabled={loading} className="bg-[#0a0a0a] text-white px-3 hover:bg-[#C5A059] hover:text-[#0a0a0a]" data-testid="chat-send"><Send size={16} /></button>
          </div>
        </div>
      )}
    </>
  );
}
